// service_ids that support payment info output
// MUFG: 4099, 4039 / GMO_AOZORA_NET: 4458
export const paymentSupportedServiceIds = [4099, 4039, 4458];